import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";
import { branchListModel } from "common/models/page-models/custom-model/branch.model";



@Injectable()
export class branchListDataService extends DataService<branchListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.branchList,http);
    }

  
    createInstance():branchListModel  {
        return new branchListModel();
    }

}
